import { render, staticRenderFns } from "./CustomerFilters.vue?vue&type=template&id=31ac0328&scoped=true"
import script from "./CustomerFilters.vue?vue&type=script&lang=js"
export * from "./CustomerFilters.vue?vue&type=script&lang=js"
import style0 from "./CustomerFilters.vue?vue&type=style&index=0&id=31ac0328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac0328",
  null
  
)

export default component.exports